import * as moment from 'moment-timezone';

import { Component, OnDestroy, OnInit } from '@angular/core';

import { CustomerService } from '../../../../services/customer/customer.service';
import { CustomerActivityType, CustomerRecentActivityResult, getLastActivityText } from '../../../../models/customer';
import { dateStringFromISO8601, timeStringFromISO8601, uncapitalizeFirstLetter } from '../../../../utils';
import { AccountService } from '../../../../services/account/account.service';
import { CapitanLocation } from '../../../../models/location';
import { LocationService } from '../../../../services/location/location.service';


@Component({
  selector: 'app-recently-active-customers',
  templateUrl: './recently-active-customers.component.html',
  styleUrls: ['./recently-active-customers.component.css']
})
export class RecentlyActiveCustomersComponent implements OnInit, OnDestroy {
  public customers: CustomerRecentActivityResult[] = null;

  public refreshIntervalHolder: any;

  public loadingCustomers = true;
  public serverError: number = null;

  public locations: CapitanLocation[] = null;
  public locationId: number | null = null;

  public readonly uncapitalizeFirstLetter = uncapitalizeFirstLetter;
  public readonly getLastActivityText = getLastActivityText;
  public readonly timeStringFromISO8601 = timeStringFromISO8601;
  public readonly dateStringFromISO8601 = dateStringFromISO8601;
  public readonly CustomerActivityType = CustomerActivityType;
  public readonly moment = moment;

  constructor(
    private customerService: CustomerService,
    private locationService: LocationService,
    private accountService: AccountService,
  ) {}

  ngOnInit() {
    this.locationId = this.accountService.getMyAccount().default_gym_id;

    this.loadCustomers();

    // Refresh data every 60 seconds.
    this.refreshIntervalHolder = setInterval(
      () => {
        this.loadCustomers();
      },
      60 * 1000
    );

    this.locations = this.locationService.getLocations();
    if (this.locations === null) {
      this.locationService.loadLocations().then(() => {
        this.locations = this.locationService.getLocations();
      })
    }
  }

  ngOnDestroy() {
    // Stop refreshing data when the component is destroyed.
    clearInterval(this.refreshIntervalHolder);
  }

  public loadCustomers() {
    this.loadingCustomers = true;

    this.customerService
      .getRecentlyActiveCustomers(this.locationId)
      .then(result => {
        this.customers = result.results;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingCustomers = false; });
  }
}
